import { DefaultTheme, ThemeProvider } from 'styled-components';

const deprecatedTheme: DefaultTheme = {
  colors: {
    red: {
      base: '#EB3C1A',
    },
    blue: {
      base: '#252F42',
      dark: '#1C2639',
      darker: '#171F2E',
      light: '#4E586D',
      lighter: '#959FB1',
    },
    purple: {
      base: '#8706BA',
    },
    green: {
      base: '#00A878',
    },
    yellow: {
      base: '#FFBF00',
    },
    gray: {
      base: '#E2E7EB',
      light: '#F0F3F6',
      lighter: '#F5F7FA',
    },
    white: {
      base: '#FFFFFF',
    },
  },
};

/**
 * @deprecated Only required to support deprecated theme usage inside styled() components
 */
const ThemeWrapper = ({ children }: { children?: React.ReactNode }) => (
  <ThemeProvider theme={deprecatedTheme}>{children}</ThemeProvider>
);

export default ThemeWrapper;
